import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { getAnalyticsClient, isSSR, pollForBrowserControlsFlag } from '../../../common/utils';
import { initializeGlobalState } from '../../../common/utils/bsc-global-state';
import { Logger } from '../../../common/utils/logger';
import { getSetCookieOverride } from './set-cookie-override';
// Hijack the document.cookie setter logic so we can track cookie and usage info if we've opted into cookies management
// This will generate a passthrough that will call the original document.cookie setter logic after we've logged analytics
export var createDocumentCookiePassthrough = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var args,
      isFlagEnabled,
      documentCookieProperty,
      originalSetter,
      originalGetter,
      analyticsWebClientInstance,
      isAnalyticsInitialized,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          args = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
          if (!isSSR()) {
            _context.next = 3;
            break;
          }
          return _context.abrupt("return");
        case 3:
          _context.t0 = args.flagEnabled;
          if (_context.t0) {
            _context.next = 8;
            break;
          }
          _context.next = 7;
          return pollForBrowserControlsFlag();
        case 7:
          _context.t0 = _context.sent;
        case 8:
          isFlagEnabled = _context.t0;
          if (isFlagEnabled) {
            _context.next = 11;
            break;
          }
          return _context.abrupt("return");
        case 11:
          initializeGlobalState(args);
          documentCookieProperty = Object.getOwnPropertyDescriptor(Document.prototype, 'cookie');
          originalSetter = documentCookieProperty === null || documentCookieProperty === void 0 ? void 0 : documentCookieProperty.set;
          originalGetter = documentCookieProperty === null || documentCookieProperty === void 0 ? void 0 : documentCookieProperty.get;
          if (!(!originalSetter || !originalGetter)) {
            _context.next = 18;
            break;
          }
          Logger.warn('No document.cookie capabilities found');
          return _context.abrupt("return");
        case 18:
          // Ensures that the AWC is constructed before overwriting document.cookie. Not
          // doing so was allowing for cases of infinite recursion.
          analyticsWebClientInstance = getAnalyticsClient(); // If AWC is not initialized, it will be undefined
          isAnalyticsInitialized = !!analyticsWebClientInstance;
          if (isAnalyticsInitialized) {
            _context.next = 22;
            break;
          }
          throw new Error('Failed to initialize AnalyticsWebClient. Analytics logging will not be set for document.cookie.');
        case 22:
          // Override document.cookie setter
          Object.defineProperty(document, 'cookie', {
            get: originalGetter,
            set: getSetCookieOverride(originalSetter),
            configurable: true
          });
        case 23:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function createDocumentCookiePassthrough() {
    return _ref.apply(this, arguments);
  };
}();
export var initializeControls = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var args,
      _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          args = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
          _context2.prev = 1;
          _context2.next = 4;
          return createDocumentCookiePassthrough(args);
        case 4:
          _context2.next = 9;
          break;
        case 6:
          _context2.prev = 6;
          _context2.t0 = _context2["catch"](1);
          Logger.errorWithOperationalEvent({
            action: 'initializeControlsError',
            message: "Failed to initialize browser storage controls. ".concat(_context2.t0.message || '')
          });
        case 9:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[1, 6]]);
  }));
  return function initializeControls() {
    return _ref2.apply(this, arguments);
  };
}();